// ===================================================
// @gam/ui — public API
// ===================================================
//
// Shared UI primitives for GAM products. Accent-aware via --cc-accent-*
// CSS variables — components automatically theme to whatever accent
// the user has selected in Settings (default: teal).
//
// Use Tailwind classes for layout/spacing/typography. The design tokens
// live in src/app/globals.css [data-accent="..."] palettes.

export { Chip } from "./Chip";
export type { ChipProps } from "./Chip";

export { StatusToggle } from "./StatusToggle";
export type { StatusToggleProps } from "./StatusToggle";

export { Field, inputCls } from "./Field";
export type { FieldProps } from "./Field";

export { SectionCard, SectionDivider } from "./SectionCard";
export type { SectionCardProps } from "./SectionCard";

export { StickyActionBar } from "./StickyActionBar";
export type { StickyActionBarProps } from "./StickyActionBar";

export { FacetPane } from "./FacetPane";
export type { FacetPaneProps, FacetValueRow } from "./FacetPane";

export { ColumnBrowser } from "./ColumnBrowser";
export type { ColumnBrowserProps, ColumnBrowserPane } from "./ColumnBrowser";

// Version marker — bump on breaking API changes.
export const VERSION = "0.1.0";
